// import { create } from 'zustand';
// import { mountStoreDevtool } from 'simple-zustand-devtools';

// const useAuthStore = create((set, get) => ({
//     allUserData: null, // Use this to store all user data
//     loading: false,
//     user: () => ({
//         user_id: get().allUserData?.user_id || null,
//         username: get().allUserData?.username || null,
//     }),
//     setUser: (user) => set({ allUserData: user }),
//     setLoading: (loading) => set({ loading }),
//     isLoggedIn: () => get().allUserData !== null,
// }));

// // this is for VITE...
// // if (import.meta.env.DEV) {
// //     mountStoreDevtool('Store', useAuthStore);
// // }

// if (process.env.NODE_ENV === 'development') {
//     mountStoreDevtool('Store', useAuthStore);
// }

// export { useAuthStore };


import { create } from 'zustand';
import { mountStoreDevtool } from 'simple-zustand-devtools';

const useAuthStore = create((set, get) => ({
    allUserData: null, // Store all user data
    csrfToken: null,    // Store CSRF token
    accessToken: null,  // Store access token
    refreshToken: null, // Store refresh token
    loading: false,     // Loading state

    // Shared across pages (Navbar's login modal lives separately from
    // e.g. the calculator page's own post-login prompts) so other pages
    // can wait for the user to dismiss the "You are logged in" modal
    // before showing their own follow-up modal, instead of both popping
    // up at once.
    showLoginWelcomeModal: false,
    setShowLoginWelcomeModal: (value) => set({ showLoginWelcomeModal: value }),

    // Which body text the modal above shows. 'new_google_account' only for
    // a brand-new account created via Google sign-in this session (see
    // login.jsx/register.jsx) — reset back to the default on every close so
    // a later ordinary login doesn't accidentally reuse the welcome copy.
    loginWelcomeVariant: 'standard',
    setLoginWelcomeVariant: (variant) => set({ loginWelcomeVariant: variant }),

    // Methods to retrieve user, CSRF token, and tokens
    user: () => ({
        user_id: get().allUserData?.user_id || null,
        username: get().allUserData?.username || null,
        // Google-only signups have no password (see GoogleLoginSerializer);
        // the account-deletion modal uses this to show the right
        // confirmation step instead of a password field they can't fill in.
        has_usable_password: get().allUserData?.has_usable_password ?? true,
        // 'Client' is the backend's placeholder for "no real name known" —
        // see MyTokenObtainPairSerializer. Treated as absent here so
        // consumers (e.g. the avatar initial) can fall back to username.
        customer_name: get().allUserData?.customer_name && get().allUserData.customer_name !== 'Client'
            ? get().allUserData.customer_name
            : null,
    }),
    getCSRFToken: () => get().csrfToken,      // Method to get the current CSRF token
    getAccessToken: () => get().accessToken,  // Method to get the access token
    getRefreshToken: () => get().refreshToken, // Method to get the refresh token

    // Methods to set user, CSRF token, access token, and refresh token
    setUser: (user) => set({ allUserData: user }),
    setCSRFToken: (token) => set({ csrfToken: token }),       // Set CSRF token
    setAccessToken: (token) => set({ accessToken: token }),   // Set access token
    setRefreshToken: (token) => set({ refreshToken: token }), // Set refresh token
    setLoading: (loading) => set({ loading }),

    // Methods to reset CSRF token, access token, refresh token, and user
    resetCSRFToken: () => set({ csrfToken: null }),           // Reset CSRF token
    resetAccessToken: () => set({ accessToken: null }),       // Reset access token
    resetRefreshToken: () => set({ refreshToken: null }),     // Reset refresh token
    resetUser: () => set({ allUserData: null }),

    // Check if the user is logged in
    isLoggedIn: () => get().allUserData !== null,
}));

// Optional: Devtools for debugging in development environment
if (process.env.NODE_ENV === 'development') {
    mountStoreDevtool('AuthStore', useAuthStore);
}

export { useAuthStore };